import { logUnusedKeys } from '@/model/Utils';

export default function (other) {
  other = other || {};
  let result = {
    range: {
      from: other.range?.from || null,
      until: other.range?.until || null,
    },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    userIds: other.userIds || [],
    types: other.types || [],
    realOnly: other.realOnly !== false,
  };
  logUnusedKeys('MonetaryDashboardSearchRequest', result, other);
  return result;
}
